import { Box } from '@mui/material';
import { LoadingState } from 'design-system';
import { ThemeVariant, getThemeVariant } from 'services/theming';
import useIsVillaProfile from 'hooks/useIsVillaProfile';
import Logo from 'images/LogoColor';
import LogoFreshmark from 'images/LogoFreshmark';
import LogoVilla from 'images/LogoVilla';
import Hero from 'images/MobileLoadingHero';
import HeroInputs from 'images/MobileLoadingHeroInputs';

const NetworkLoading = ({ hideHero = false, bottom = 48 }: { hideHero?: boolean; bottom?: number }) => {
  const themeVariant = getThemeVariant();
  const isVillaProfile = useIsVillaProfile();
  const showHero = !hideHero && [ThemeVariant.Nile, ThemeVariant.Inputs].includes(themeVariant);
  return (
    <LoadingState
      bottom={bottom}
      logo={
        <>
          {themeVariant === ThemeVariant.FreshMark && <Box component={LogoFreshmark} sx={{ width: 130 }} />}
          {isVillaProfile && <Box component={LogoVilla} sx={{ width: 130 }} />}
          {[ThemeVariant.Nile, ThemeVariant.Inputs].includes(themeVariant) && !isVillaProfile && (
            <Box component={Logo} sx={{ maxHeight: 80, maxWidth: 100 }} />
          )}
        </>
      }
      hero={showHero && (ThemeVariant.Inputs === themeVariant ? <HeroInputs /> : <Hero />)}
    />
  );
};

export default NetworkLoading;
